import React from 'react';
import { Navigate } from 'react-router-dom';
import { isPlatformAuthenticated } from '../../utils/platformAuth';

interface PlatformProtectedRouteProps {
  children: React.ReactNode;
}

const PlatformProtectedRoute: React.FC<PlatformProtectedRouteProps> = ({ children }) => {
  return isPlatformAuthenticated() ? (
    <>{children}</>
  ) : (
    <Navigate to="/platform-admin/login" replace />
  );
};

export default PlatformProtectedRoute;
